export default function CustomersUsers() {
    
    return (
        <><iframe title="New User Entity" width="1024" height="1060" src={process.env.REACT_APP_CUSTOMERS_USERS_URL} frameborder="0" allowFullScreen="true"></iframe></>
    )
}